var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dropdown',
    { 'is-error': _vm.isError && this.validatedValue !== 0 }
]},[_c('select',{attrs:{"aria-label":"Wybierz"},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":"null"},domProps:{"textContent":_vm._s(_vm.placeholder)}}),_vm._l((_vm.items),function(item,i){return _c('option',{key:i,domProps:{"value":item.value,"textContent":_vm._s(item.label)}})})],2),_c('i',{staticClass:"icon-arrow-down"})])}
var staticRenderFns = []

export { render, staticRenderFns }